export default (cents) => (cents / 100).toString().replace('.', ',')
